module.exports = __webpack_public_path__ + "posture/static/img/round_shoulder_left.7676055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/round_shoulder_left.png
// module id = bFmA
// module chunks = 1